module.exports = __webpack_public_path__ + "img/section2_img.14a057a2.svg";